export const selectMonitoreosInternetState = (state) => state.monitoreosInternet;

export const selectMonitoreosInternetFormState = (state) => state.monitoreosInternet.form;
